module.exports = __webpack_public_path__ + "media/scholarships/fastweb-x-gradcap-85ff29f5.svg";